<template>
  <div
    class="categorise-item grid gap-2"
  >
    <div class="font-bold">
      {{ item.value }}
    </div>
    <div class="flex gap-2 flex-wrap">
      <div
        v-for="(option, index) in item.options"
        :key="index"
        class="p-1 border border-secondary-20 rounded-md flex gap-1 items-center"
      >
        {{ option.value }}
        <aha-icon
          class="checkmark"
          :name="getStatus(option)"
          width="16"
          height="16"
          viewBox="0 0 18 18"
          v-if="showCheckMarkIcon"
        ></aha-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoriseItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    showCheckMarkIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getStatus(option) {
      return option.correct === true ? 'correct' : 'incorrect'
    },
  },
}
</script>

<style lang="scss" scoped>
.categorise-item {
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid var(--secondary-20, #D3D7E1);
  padding: 12px;

  svg[name="correct"] {
    &.checkmark {
      @apply text-green-50;
      visibility: visible;
    }
  }

  svg[name="incorrect"] {
    &.checkmark {
      @apply text-red-100;
      visibility: visible;
    }
  }
}
</style>
